import { autoinject, LogManager } from 'aurelia-framework';
import { Router } from 'aurelia-router';
import { EntityManager } from 'aurelia-orm';
import { DialogService } from 'aurelia-dialog';
import { ValidationController } from 'aurelia-validation';
import { EventAggregator, Subscription } from 'aurelia-event-aggregator';
import { BootstrapFormRenderer } from 'core/bootstrap-form-renderer';
import { AppEvents } from 'core/app-events';
import { Item } from 'data/entities/item';
import { ItemRepository } from 'data/repository/item-repository';
import { ItemTypes } from 'core/enums';

@autoinject
export class AddTicket {
    ticket: Item;
	eventSubscriptions: Array<Subscription> = [];

	constructor(
		private entityManager: EntityManager,
		private dialogService: DialogService,
		private validationController: ValidationController,
		private eventAggregator: EventAggregator,
		private router: Router,
		private bootstrapFormRenderer: BootstrapFormRenderer) {
			this.itemRepository = this.entityManager.getRepository(Item);
			this.validationController.addRenderer(bootstrapFormRenderer);
	}

	private unsubscribeFromEvents() {
		for (const entry of this.eventSubscriptions) {
			entry.dispose();
		}
		this.eventSubscriptions = [];
	}

	onDirectoryChanged(payload) {
		this.initialize();
	}

	subscribeToEvents() {
		this.eventSubscriptions._add(this.eventAggregator.subscribe(AppEvents.DIRECTORY_CHANGED, payload => {
			this.onDirectoryChanged(payload);
		}));
	}

	activate() {
		this.subscribeToEvents();
		this.initialize();
	}

	deactivate() {
		this.unsubscribeFromEvents();
	}

	initialize() {
		this.ticket = this.itemRepository.getNewEntity();
		this.ticket.itemTypeId = ItemTypes.SupportTicket;		
	}

	className = "AddTicketViewModel";
	itemRepository: ItemRepository;
	logger = LogManager.getLogger(this.className);

	async addTicket() {
		this.logger.info("Saving Support Ticket");
		try {
			const result = await this.validationController.validate();
			if (result.valid) {
				// validation succeeded
				await this.ticket.save();
				this.logger.info("Saved Support Ticket Successfully");
				this.router.navigateToRoute('support');
			} else {
				console.log("failure");
				// validation failed
			}
		}
		catch (exception) {
			this.logger.error(exception);
		}
	}

	cancel() {
		this.router.navigateToRoute('support');
	}
}